import {
    Component,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    ElementRef,
    NgZone,
    AfterViewInit,
    Signal,
    viewChild,
    inject
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RequestsStatusPillComponent } from '../requests-status-pill/requests-status-pill.component';
import { ITableActivity } from './models/table-acitivty.model';

@Component({
    selector: 'app-activity-stream',
    templateUrl: './activity-stream.component.html',
    imports: [DatePipe, RequestsStatusPillComponent, TranslateModule],
    host: { class: 'flex flex-col flex-1 min-h-0 overflow-hidden' }
})
export class ActivityStreamComponent implements AfterViewInit {
    public items: InputSignal<ITableActivity[]> = input<ITableActivity[]>([]);
    public loading: InputSignal<boolean> = input<boolean>(true);
    public loadMore: OutputEmitterRef<void> = output<void>();

    public scrollContainer: Signal<ElementRef<HTMLDivElement>> =
        viewChild.required<ElementRef<HTMLDivElement>>('scrollContainer');

    private scrollThreshold = 100;

    private ngZone: NgZone = inject(NgZone);

    public ngAfterViewInit(): void {
        this.setupInfiniteScroll();
    }

    private setupInfiniteScroll(): void {
        if (this.scrollContainer()?.nativeElement) {
            this.ngZone.runOutsideAngular(() => {
                this.scrollContainer()?.nativeElement.addEventListener('scroll', () => {
                    this.checkScrollPosition();
                });
            });
        }
    }

    private checkScrollPosition(): void {
        if (this.loading()) {
            return;
        }

        const element = this.scrollContainer()?.nativeElement;
        const scrollPosition = element.scrollTop + element.clientHeight;
        const scrollHeight = element.scrollHeight;

        if (scrollHeight - scrollPosition <= this.scrollThreshold) {
            this.ngZone.run(() => {
                this.loadMore.emit();
            });
        }
    }
}
